module.exports = __webpack_public_path__ + "components/country-flag/static/hu-6a654f783660a60733b03f1745f26a55.svg";